import axios from 'axios'
import _Vue from 'vue'

const http = axios.create({
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
  },
  timeout: 5000,
})

http.interceptors.response.use((response) => {
  return response
}, (error) => {
  return Promise.reject(error)
})

export default {
  install(Vue: typeof _Vue, name = '$http') {
    Object.defineProperty(Vue.prototype, name, { value: http })
  },
}
